"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBlockOffset_1 = __importDefault(require("../query/getBlockOffset"));
const utils_1 = require("../utils");
const getFragmentNode_1 = __importDefault(require("./getFragmentNode"));
exports.default = (listState) => {
    const domSelection = window.getSelection();
    if (domSelection == null || domSelection.anchorNode == null) {
        return null;
    }
    let { anchorOffset, focusOffset, } = domSelection;
    const _anchorNode = domSelection.anchorNode;
    const _focusNode = domSelection.focusNode;
    const anchorNode = getFragmentNode_1.default(_anchorNode);
    const focusNode = getFragmentNode_1.default(_focusNode);
    if (anchorNode != null && focusNode != null) {
        anchorOffset = utils_1.getUTF16Length(anchorNode.innerText.slice(0, anchorOffset));
        focusOffset = utils_1.getUTF16Length(focusNode.innerText.slice(0, focusOffset));
    }
    if (anchorNode == null || focusNode == null) {
        return null;
    }
    const anchorKey = anchorNode.dataset.blockKey;
    const focusKey = focusNode.dataset.blockKey;
    const anchorFragmentOffset = parseInt(anchorNode.dataset.fragmentStart);
    const focusFragmentOffset = parseInt(focusNode.dataset.fragmentStart);
    anchorOffset += (getBlockOffset_1.default(listState, anchorKey) || 0) + anchorFragmentOffset;
    focusOffset += (getBlockOffset_1.default(listState, focusKey) || 0) + focusFragmentOffset;
    const [start, end] = [anchorOffset, focusOffset].sort((a, b) => a - b);
    return {
        start,
        end,
        anchorOffset,
        focusOffset
    };
};
//# sourceMappingURL=getDomSelection.js.map